import { render, staticRenderFns } from "./LomInformation.vue?vue&type=template&id=d8ba70b2&scoped=true"
import script from "./LomInformation.vue?vue&type=script&lang=js"
export * from "./LomInformation.vue?vue&type=script&lang=js"
import style0 from "./LomInformation.vue?vue&type=style&index=0&id=d8ba70b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ba70b2",
  null
  
)

export default component.exports